import SmoothScroll from 'smooth-scroll';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener("DOMContentLoaded", () => {
	// ボタンのイベントを削除
	const hamburgerMenu = document.querySelector(".main-nav__humberger");
	const cloneHamburgerMenu = hamburgerMenu.cloneNode(true);
	hamburgerMenu.replaceWith(cloneHamburgerMenu);

	const pageScroll = new SmoothScroll('a[href*="#"]', {
		speed: 500,
		speedAsDuration: true,
		header: "#header"
	});

	//
	infinite();
	faqAction();
	makeFeatureList();

	const swiperpc = new Swiper('.mv-pc', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
		  el: ".page-pc",
		},
	});
	const swipersp = new Swiper('.mv-sp', {
		slidesPerView: 1,
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		pagination: {
		  el: ".page-sp",
		},
	});

	//from Root blog
	let previousVerticalPos = 0

	const isInViewport = (el) => {
		const rect = el.getBoundingClientRect();
		const vWidth = window.innerWidth || document.documentElement.clientWidth;
		const vHeight = window.innerHeight || document.documentElement.clientHeight;
		const efp = (x, y) => {
			return document.elementFromPoint(x, y);
		}
		// Return false if it's not in the viewport
		if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) return false;
		// Return true if any of its four corners are visible
		return (
			el.contains(efp(rect.left, rect.top))
			|| el.contains(efp(rect.right, rect.top))
			|| el.contains(efp(rect.right, rect.bottom))
			|| el.contains(efp(rect.left, rect.bottom))
		);
	}
	const checkOnScroll = () => {
		//Frame in anime
		// const fiAnime = Array.prototype.slice.call(document.querySelectorAll(".top_anime_fi"),0)
		// if (fiAnime!==undefined) addClassInView(fiAnime)

		//Floating navi
		const $mainNav = document.querySelectorAll(".main-nav__list")[0];
		const $floating = document.querySelectorAll(".footer__floating")[0];
		if ($mainNav !== undefined) {
			if (isInViewport($mainNav)) {
				$floating.classList.remove("fadein");
			} else {
				$floating.classList.add("fadein");
			}
		}

		// const currentVerticalPos = document.documentElement.scrollTop;
		// const $body = document.querySelectorAll("body")[0];
		// const $header = document.getElementById("header");
		// const $main = document.querySelectorAll("main")[0];
		// const removeSpace = () => {
		// 	$main.style.paddingTop = `0`;
		// 	$body.classList.remove("fixed");
		// }
		// if (!isSp()) {
		// 	if ($body !== undefined && $header !== undefined && $main !== undefined) {
		// 		if (previousVerticalPos < currentVerticalPos) {
		// 			removeSpace();
		// 		} else {
		// 			const headerHeight = $header.clientHeight;
		// 			$main.style.paddingTop = `${headerHeight}px`;
		// 			$body.classList.add("fixed");
		// 		}
		// 		if (previousVerticalPos === currentVerticalPos || currentVerticalPos <= 0) {
		// 			removeSpace();
		// 		}
		// 	}
		// } else {
		// 	removeSpace();
		// }
		// previousVerticalPos = currentVerticalPos
	}

	window.addEventListener("scroll", () => {
		checkOnScroll();
	});
	checkOnScroll();

	//遅延ロード
	const lazyLoad = Array.prototype.slice.call(document.body.querySelectorAll(".js-lazy-load"), 0);
	const options = {
		rootMargin: "0px",
		threshold: [0]
	};
	const lazyLoader = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				// console.log(t)
				const $t = t.target;
				const data = $t.dataset.src;
				$t.setAttribute("src", data);
				// console.log($t,data)
				isObserver.unobserve($t);
			}
		})
	}
	const isObserver = new IntersectionObserver(lazyLoader, options)
	lazyLoad.forEach(el => {
		isObserver.observe(el);
	})

	const fiAnime = Array.prototype.slice.call(document.querySelectorAll(".top_anime_fi"), 0)
	const addfiAnime = (el) => {
		el.forEach(t => {
			if (t.intersectionRatio > 0) {
				const $t = t.target;
				// console.log("t:",$t)
				$t.classList.add("top_anime_show");
				isObserver.unobserve($t);
			}
		})
	}
	const isObserverAnime = new IntersectionObserver(addfiAnime, options)
	fiAnime.forEach(el => {
		isObserverAnime.observe(el);
	});

	//Privacy Policy
	const checkedCheck = (el) => {
		const $submit = document.getElementById("submit");
		const $t = el;
		// console.log($t.checked)
		if ($t.checked) {
			$submit.disabled = false;
		} else {
			$submit.disabled = true;
		}
	}

	const $privacyCheck = document.getElementById("privacypolicy");
	if ($privacyCheck !== null) {
		checkedCheck($privacyCheck);
		if ($privacyCheck) {
			$privacyCheck.addEventListener("change", el => {
				checkedCheck(el.target);
			})
		}
	}
});

//文字列をリストに
function makeFeatureList() {
	const sorceDiv = document.querySelectorAll(".contract_feature_list");
	sorceDiv.forEach((element) => {
		const text = element.textContent;
		const lines = text.split("\n");
		const html = lines.map(line => `<li>${line.trim()}</li>`).join("");
		element.innerHTML = `<ul>${html}</ul>`;
	})
}

//FAQのトグル動作
function faqAction() {
	const faq = document.querySelectorAll(".contract_faq dl dt");
	faq.forEach((element) => {
		element.addEventListener("click", (event) => {
			const dt = event.currentTarget;
			// const dd = dt.nextElementSibling;
			const dl = dt.parentElement;
			dl.classList.toggle("open");
		});
	});
}

//ロゴスクロール
function infinite() {
	const imgWidth = 240;
	const marquee = document.querySelector('.marquee');
	const marqueeInner = document.querySelector('.contract_users_logo');
	if (marqueeInner) {
		const logos = [...marqueeInner.children];
		const logoSetWidth = imgWidth * logos.length; // 画像の幅がimgWidth pxとして計算

		// 必要なクローンセット数を計算
		const numberOfClones = Math.ceil((marquee.offsetWidth - logoSetWidth) / logoSetWidth) + 1;

		// 必要なセット数だけクローンを作成
		for (let i = 0; i < numberOfClones; i++) {
			logos.forEach(logo => marqueeInner.appendChild(logo.cloneNode(true)));
		}
		// アニメーションの更新
		const animationCSS = `
			@keyframes marquee {
				0% \{ transform: translateX(0); }
				100% \{ transform: translateX(-` + logoSetWidth + `px); }
			}
			`;
		const styleElem = document.createElement('style');
		styleElem.textContent = animationCSS;
		document.head.appendChild(styleElem);
	}
}
